import '/app/brewery-packages/content/content-editor-plugin-list-item/src/ListItem.css-raw';
export default {
  "listItem": "news-4a753f38-listItem-zUCuRq"
};